// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-eb1078f7] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.content[data-v-eb1078f7] {
  box-sizing: border-box;
  margin: var(--body-container-margin);
  margin-top: 50px;
  display: flex;
  width: calc(100% - var(--body-container-margin) * 2);
  border-radius: var(--body-container-radius);
  height: var(--body-height);
  overflow: hidden;
  padding: 0;
}
.content[data-v-eb1078f7]:not(.with-sidebar--full) {
  position: fixed;
}
.content[data-v-eb1078f7] * {
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/index-a9e4fe04.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,oDAAoD;EACpD,2CAA2C;EAC3C,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-eb1078f7] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.content[data-v-eb1078f7] {\n  box-sizing: border-box;\n  margin: var(--body-container-margin);\n  margin-top: 50px;\n  display: flex;\n  width: calc(100% - var(--body-container-margin) * 2);\n  border-radius: var(--body-container-radius);\n  height: var(--body-height);\n  overflow: hidden;\n  padding: 0;\n}\n.content[data-v-eb1078f7]:not(.with-sidebar--full) {\n  position: fixed;\n}\n.content[data-v-eb1078f7] * {\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
